// import { getLoginApp } from "@/api/index";
import { getCookie, setCookie } from '@/utils/cookie';

export async function userEditPwdFun () {
    let userEditPwd
    if (getCookie("userEditPwd")) {
        userEditPwd = JSON.parse(getCookie("userEditPwd"))
    } else {
        let params = {
            appDomainName: window.location.href
        }
        // await getLoginApp(params).then(res=> {
        //     if (res.code == 200) {
        //         setCookie('userEditPwd', JSON.stringify(res.data.userEditPwd))
        //         userEditPwd = JSON.parse(res.data.userEditPwd)
        //     }
        // })
    }
    return userEditPwd
}

